import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const CUSTOMER_DOCUMENT_PERMISSIONS = {
  READ: 'customer_documents:read',
  REVIEW: 'customer_documents:review',
  PUBLISH: 'customer_documents:publish',
} as const;

export function canSeeCustomerDocumentMenu(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, CUSTOMER_DOCUMENT_PERMISSIONS.READ);
}
